import React from 'react';
import styles from './styled-mobile-default-text.module.scss';

interface Props {
    text: string;
}

export function StyledMobileDefaultText({
    text
}: Props) {
    return (
        <div className={styles.defaultText}>
            {text}
        </div>
    );
}



